/**
 * La Coochie video reel (sections/lc-video-reel.liquid): the two arrows scroll the track by two cards.
 * The step is measured from the first card's width plus the flex gap, so it follows the CSS instead of a constant.
 * Smooth scrolling is skipped when the visitor prefers reduced motion. In the theme editor, selecting a Video block
 * scrolls it into view (shopify:block:select).
 */
import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

const CARDS_PER_CLICK = 2;

class LcVideoReel extends Component {
  requiredRefs = ['track'];

  connectedCallback() {
    super.connectedCallback();
    // Theme editor only: selecting a Video block in the sidebar centers it in the track.
    if (window.Shopify?.designMode) document.addEventListener('shopify:block:select', this.#onBlockSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('shopify:block:select', this.#onBlockSelect);
  }

  /** @param {Event} event */
  #onBlockSelect = (event) => {
    const { target } = event;
    if (!(target instanceof HTMLElement) || !this.contains(target)) return;
    const item = target.closest('.lc-reel__item');
    item?.scrollIntoView({ inline: 'center', block: 'nearest', behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
  };

  prev() {
    this.#scroll(-1);
  }

  next() {
    this.#scroll(1);
  }

  /** @param {1 | -1} direction */
  #scroll(direction) {
    const { track } = this.refs;
    if (!(track instanceof HTMLElement)) return;
    const first = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = first ? (first.getBoundingClientRect().width + gap) * CARDS_PER_CLICK : track.clientWidth;
    track.scrollBy({ left: direction * step, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
  }
}

if (!customElements.get('lc-video-reel')) {
  customElements.define('lc-video-reel', LcVideoReel);
}
